import {AppNavigationState} from './app-navigation.state';

export const initialAppNavigationState: AppNavigationState = {
  buttonStates: {},
  buttonVisibility: {},
};
